
import { Component, Mixins, Ref } from 'vue-property-decorator'
import axios from 'axios'
import StepNavigation from '@/components/processing_steps/StepNavigation.vue'
import FormButtons from '@/components/processing_steps/FormButtons.vue'
import FormTitle from '@/components/processing_steps/FormTitle.vue'
import AddressForm from '@/components/processing_steps/commons/forms/AddressForm.vue'
import StepContainer from '../commons/StepContainer.vue'
import FormContainer from '../commons/forms/FormContainer.vue'
import ContactPersonSelect from '../commons/forms/ContactPersonSelect.vue'
import { API_URLS } from '@/utils/helpers'
import ProcessingStepMixin from '../ProcessingStepMixin.vue'
import PSBankAccountForm from '../commons/forms/PSBankAccountForm.vue'
import { IPhoto } from '@/types/photos'
import DocumentField from '../commons/fields/DocumentField.vue'
import {
  IPSAddressForm,
  IPSAddressFormErrors,
  IPSEditFundingScope,
  IPSFundingScopeBaseForm,
  IPSFundingScopeBaseFormErrors,
  IPSWhatWeDoForm,
  IProcessingStep
} from '@/types/processingSteps'
import BaseInformationForm from '@/components/processing_steps/funding_scope/forms/BaseInformationForm.vue'
import TextFieldEditor from '../commons/fields/TextFieldEditor.vue'
import NavigationLinks from '@/components/navigation_link/NavigationLinks.vue'
import FundingScopeSummaryMixin from './mixins/FundingScopeSummaryMixin.vue'
import AccountPublishFundingScopeForm from './completition_forms/AccountPublishFundingScopeForm.vue'
import FundingScopeIsPublicForm from './completition_forms/FundingScopeIsPublicForm.vue'
import { INavigationLink } from "@/types/foerderApp"
import SubCategoryForm from '../commons/forms/SubCategoryForm.vue'
import FundingScopesOrgaWaitingForReview from './completition_forms/FundingScopesOrgaWaitingForReview.vue'
import BaseInformationStep from './steps/BaseInformationStep.vue'
import WhatWeDoStep from './steps/WhatWeDoStep.vue'
import AdminCompletitionForm from './completition_forms/AdminCompletitionForm.vue'

@Component({
  components: {
    SubCategoryForm,
    StepNavigation,
    FormTitle,
    FormButtons,
    AddressForm,
    StepContainer,
    FormContainer,
    ContactPersonSelect,
    PSBankAccountForm,
    DocumentField,
    BaseInformationForm,
    TextFieldEditor,
    NavigationLinks,
    AccountPublishFundingScopeForm,
    FundingScopeIsPublicForm,
    FundingScopesOrgaWaitingForReview,
    BaseInformationStep,
    WhatWeDoStep,
    AdminCompletitionForm
  }
})
export default class EditFundingScope extends Mixins(ProcessingStepMixin, FundingScopeSummaryMixin) {
  @Ref() contactPersonSelect!: ContactPersonSelect
  @Ref() subCategoryForm!: SubCategoryForm
  projectCategoryAvailability = false
  fundingScopeSlug: string | null = null
  fundingScope: IPSEditFundingScope | null = null
  availableOrganizations: { value: string, text: string }[] = []
  // todo set extistinglogos like here and in EditProject.vue
  // check the FundingScopeEditSerializer and add the required fields for logo
  exitstingDocuments: IPhoto[] = []
  existingPhotos: IPhoto[] = []
  existingLogos: IPhoto[] = []
  termsAccepted = false

  isCreate = true
  orgaUserCanEdit = true

  bankAccountForm = {
    owner: "",
    bank_name: "",
    iban: "",
    bic: "",
    termsAccepted: false
  }

  bankAccountFormErrors = {
    owner: "",
    bank_name: "",
    iban: "",
    bic: ""
  }

  whatWeDoForm: IPSWhatWeDoForm = {
    description_1: "",
    url_1: "",
    url_2: "",
    photo: ""
  }

  whatWeDoFormErrors: IPSWhatWeDoForm = {
    description_1: "",
    url_1: "",
    url_2: "",
    photo: ""
  }

  fundingScopeForm: IPSFundingScopeBaseForm = {
    name: "",
    related_organization: ""
  }

  fundingScopeFormErrors: IPSFundingScopeBaseFormErrors = {
    name: ""
  }

  addressForm: IPSAddressForm = {
    street: "",
    additional_information: "",
    postal_code: "",
    city: "",
    region: "",
    country: "DE"
  }

  addressFormErrors: IPSAddressFormErrors = {
    street: "",
    postal_code: "",
    city: "",
    region: "",
    country: ""
  }

  firstStep: IProcessingStep = {
    key: "basic",
    title: "Basisinformationen",
    completed: false,
    required: true,
    active: true,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  secondStep: IProcessingStep = {
    key: "what_we_do",
    title: this.$gettext("What we do"),
    completed: false,
    required: true,
    active: false,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  thirdStep: IProcessingStep = {
    key: "contact_persons",
    title: this.$gettext("Contact persons"),
    completed: false,
    required: true,
    active: false,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  fourthStep: IProcessingStep = {
    key: "assignment",
    title: this.$gettext("Categories and tags"),
    completed: false,
    required: true,
    active: false,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  fifthStep: IProcessingStep = {
    key: "bank_account",
    title: "Bankverbindung",
    completed: false,
    required: true,
    active: false,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  sixthStep: IProcessingStep = {
    key: "completition",
    title: this.$gettext("Release"),
    completed: false,
    required: true,
    active: false,
    buttons: {
      save: this.isSiteAdmin
    }
  }

  get hasImage (): boolean {
    return this.fundingScope && this.fundingScope.photos && this.fundingScope.photos.length > 0
  }

  get fundingScopeHasBankData (): boolean {
    return !!(this.fundingScope && this.fundingScope.owner && this.fundingScope.bank_name && this.fundingScope.iban && this.fundingScope.bic && this.bankAccountForm.termsAccepted)
  }

  get addContactPersonToInstanceUrl(): string {
    return API_URLS.CONTACT_PERSON.ADD_TO_INSTANCE
  }

  get fundingScopeAddressComplete (): boolean {
    return !!(this.fundingScope && this.fundingScope.street && this.fundingScope.postal_code && this.fundingScope.city && this.fundingScope.country)
  }

  get basicInfoCompleted (): boolean {
    return this.fundingScope && this.fundingScope.name && this.fundingScopeAddressComplete
  }

  get basicInfoFormCompleted (): boolean {
    return !!this.fundingScopeForm.name && !!this.fundingScopeForm.related_organization
  }

  get orgaWaitingForReview (): boolean {
    return this.fundingScope && this.fundingScope.related_organization && this.fundingScope.related_organization.review_status.choice === 1
  }

  get isPublic (): boolean {
    return this.fundingScope ? this.fundingScope.status.choice === 2 : false
  }

  get isArchived (): boolean {
    return this.fundingScope ? this.fundingScope.status.choice === 3 : false
  }

  get isDraft (): boolean {
    return this.fundingScope ? this.fundingScope.status.choice === 1 : false
  }

  async mounted (): Promise<void> {
    await this.setProjectCategoryAvailability()
    this.isCreate = window.location.pathname.endsWith("create/")
    if (!this.isCreate) {
      this.fundingScopeSlug = window.location.pathname.split("funding-scopes/")[1].split("/update/")[0]
    }
    await this.fetchFundingScope()
    await this.setAllData()
  }

  async setAllData (): Promise<void> {
    this.setSteps()
    this.setActiveStep(null)
    await this.fetchAvailableOrganizations()
    this.setBasicInfoForm()
    this.updateBreadCrumbs()
    this.checkAndValidateSteps()
    this.termsAccepted = this.isPublic || false
  }

  setTagStep (valid: boolean) {
    this.fundingScope.tag_step_is_valid = valid
    this.checkAndValidateStep(this.activeStep)
  }

  checkAndValidateSteps (): void {
    this.steps.forEach((step: IProcessingStep) => {
      this.checkAndValidateStep(step)
    })
  }

  async checkAndValidateStep(step: IProcessingStep) {
    if (step.required === false) {
      this.setAdditionalStepValid(step)
      return
    }
    if (step.key === "basic") {
      if (this.basicInfoCompleted) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === "contact_persons") {
      if (this.fundingScope && this.fundingScope.has_public_contact_person && this.fundingScope.has_internal_contact_person) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === "bank_account") {
      if (this.fundingScope && this.fundingScopeHasBankData) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === 'assignment') {
      if (this.fundingScope?.tag_step_is_valid) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === "what_we_do") {
      if (this.whatWeDoForm.description_1 && this.hasImage) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    } else if (step.key === 'completition') {
      if (this.isPublic || this.isArchived) {
        this.setAdditionalStepValid(step)
      } else {
        this.setAdditionalStepInvalid(step)
      }
    }
  }

  get requiredFieldsComplete (): boolean {
    const requiredStepsKeys = ["basic", "what_we_do", "contact_persons", "bank_account", "assignment"]
    for (const key of requiredStepsKeys) {
      const step = this.steps.find(step => step.key === key)
      if (!step || !step.completed) {
        return false
      }
    }
    return true
  }

  async handleContactPersonsUpdated (): Promise<void> {
    await this.fetchFundingScope()
    this.checkAndValidateSteps()
  }

  updateBreadCrumbs() {
    // todo do the same for the other components
    // todo add urls
    const tableUrl = "/account/funding-scopes/"
    const createUrl = ""
    let breadcrumbs = []
    const fundingScopeIcon = "fundingScopeIcon"
    if (this.isCreate) {
      breadcrumbs = [
        { title: this.$gettext("Funding scopes"), url: tableUrl, icon: fundingScopeIcon },
        { title: this.$gettext("Create"), url: createUrl }
      ]
    } else {
      breadcrumbs = [
        { title: this.$gettext("Funding scopes"), url: tableUrl, icon: fundingScopeIcon },
        { title: this.fundingScope.name, url: '/processing-steps/' }
      ]
    }
    this.$emit("breadcrumbs-set", breadcrumbs) // emits to ProcessingSteps.vue to set the new breadcrumbs
  }

  get documentUploadUrl (): string {
    if (!this.fundingScope) { return "" }
    return API_URLS.PHOTOS.UPLOAD_PHOTO(this.fundingScope.document_album_slug)
  }

  get photoUploadUrl (): string {
    if (!this.fundingScope) { return "" }
    return API_URLS.PHOTOS.UPLOAD_PHOTO(this.fundingScope.photo_album_slug)
  }

  get logoUploadUrl (): string {
    if (!this.fundingScope) { return "" }
    return API_URLS.PHOTOS.UPLOAD_PHOTO(this.fundingScope.logo_album_slug)
  }

  setBasicInfoForm () {
    // todo if not create, set the oter fields for first step
    // add functions to set the forms for the other steps
    let relatedOrganization = this.availableOrganizations.length > 0 ? this.availableOrganizations[0].value : ""
    if (this.fundingScope && this.fundingScope.related_organization && this.fundingScope.related_organization.slug !== "") {
      relatedOrganization = this.fundingScope.related_organization.slug
    }
    this.fundingScopeForm.related_organization = relatedOrganization
    if (this.fundingScope) {
      this.fundingScopeForm = {
        name: this.fundingScope.name,
        related_organization: relatedOrganization
      }
      this.whatWeDoForm = {
        description_1: this.fundingScope.description_1 || "",
        url_1: this.fundingScope.url_1 || "",
        url_2: this.fundingScope.url_2 || "",
        photo: ""
      }
    }
  }

  setAddressForm () {
    if (this.fundingScope) {
      this.addressForm.street = this.fundingScope.street
      this.addressForm.additional_information = this.fundingScope.additional_information
      this.addressForm.postal_code = this.fundingScope.postal_code
      this.addressForm.city = this.fundingScope.city
      this.addressForm.region = this.fundingScope.region
      this.addressForm.country = this.fundingScope.country ? this.fundingScope.country : "DE"
    }
  }

  setBankForm () {
    if (this.fundingScope) {
      const allFieldsFilled = !!this.fundingScope.owner && !!this.fundingScope.bank_name && !!this.fundingScope.iban && !!this.fundingScope.bic
      this.bankAccountForm.owner = this.fundingScope.owner
      this.bankAccountForm.bank_name = this.fundingScope.bank_name
      this.bankAccountForm.iban = this.fundingScope.iban
      this.bankAccountForm.bic = this.fundingScope.bic
      this.bankAccountForm.termsAccepted = allFieldsFilled
    }
  }

  setExistingDocuments () {
    if (this.fundingScope) {
      this.exitstingDocuments = this.fundingScope.documents
    }
  }

  setExistingPhotos () {
    if (this.fundingScope) {
      this.existingPhotos = this.fundingScope.photos
    }
  }

  setExistingLogos () {
    if (this.fundingScope) {
      this.existingLogos = this.fundingScope.logos
    }
  }

  async fetchAvailableOrganizations (): Promise<void> {
    await axios.get(API_URLS.PROCESSING_STEPS.AVAILABLE_ORGANIZATIONS).then((response) => {
      this.availableOrganizations = response.data
    }).catch(() => {
      this.showError(null)
    })
  }

  getFundingScopeSlugFromUrl (): string {
    return window.location.pathname.split("funding-scopes/")[1].split("/update/")[0]
  }

  async fetchFundingScope (): Promise<void> {
    if (this.isCreate) {
      return
    }
    let url = "/api/v4/funding-scopes/"
    this.fundingScopeSlug = this.getFundingScopeSlugFromUrl()
    url += this.fundingScopeSlug + "/edit-data/"

    await axios.get(url).then((response) => {
      this.fundingScope = response.data
      this.setAddressForm()
      this.setBankForm()
      this.setExistingDocuments()
      this.setExistingPhotos()
      this.setExistingLogos()
    }).catch(() => {
      this.showError(null)
    })
  }

  setSteps (): void {
    this.steps = [
      this.firstStep,
      this.secondStep,
      this.thirdStep,
      ...(this.projectCategoryAvailability ? [this.fourthStep] : []), // only add the step if tags available
      this.fifthStep,
      this.sixthStep
    ]
  }

  async setProjectCategoryAvailability() {
    // for the component with the tags (SubCategory) to select
    await axios.get("/api/v4/projectcategories/?available_for=funding_scopes").then((response) => {
      this.projectCategoryAvailability = response.data.results.length > 0
    })
  }

  isActiveStep (step: IProcessingStep): boolean {
    return this.activeStep === step
  }

  changeStep (step: IProcessingStep): void {
    this.activeStep = step
  }

  handlePhotosChanged (fundingScope: IPSEditFundingScope): void {
    this.fundingScope = fundingScope
  }

  getUpdateUrl (slug: string): string {
    if (this.isSiteAdmin) {
      return "/site-admin/funding-scopes/" + slug + "/update/"
    } else {
      return "/account/funding-scopes/" + slug + "/update/"
    }
  }

  async createFundingScope (): Promise<boolean> {
    if (this.fundingScopeSlug) { return true }
    this.resetBaseInformationFormErrors()
    let created = false
    const payload = {
      ...this.fundingScopeForm,
      ...this.addressForm
    }
    await axios.post(API_URLS.FUNDING_SCOPE.LIST, payload).then(async (response) => {
      created = true
      this.isCreate = false
      this.showObjectCreatedSuccessMsg(
        this.$gettext("Funding scope")
      )
      this.fundingScopeSlug = response.data.slug
      const updateUrl = this.getUpdateUrl(this.fundingScopeSlug)
      window.history.pushState({}, "", updateUrl)
    }).catch((error) => {
      this.setBaseInformationFormErrors(error)
      this.showRequiredFieldsError()
    })
    return created
  }

  async saveBaseInformation (): Promise<boolean> {
    this.resetBaseInformationFormErrors()
    let saved = false
    const payload = {
      ...this.fundingScopeForm,
      // don't send null values for address fields, but empty strings instead, to get empty field errors
      ...Object.fromEntries(
        Object.entries(this.addressForm).map(([key, value]) => [key, value === null ? "" : value])
      )
    }
    await axios.put(API_URLS.FUNDING_SCOPE.RETRIEVE(this.fundingScopeSlug), payload).then(() => {
      saved = true
      this.showSuccessMsg(null)
    }).catch((error) => {
      if (error.response && error.response.status === 403 && error.response.data && error.response.data.detail) {
        this.showError({
          title: this.$gettext("Error"),
          message: error.response.data.detail
        })
      } else {
        this.setBaseInformationFormErrors(error)
        this.showRequiredFieldsError()
      }
    })
    return saved
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setBaseInformationFormErrors (error: any): void {
    const errorMessages = error.response.data

    this.fundingScopeFormErrors = {
      name: errorMessages.name ? errorMessages.name[0] : ""
    }

    this.addressFormErrors = {
      street: errorMessages.street ? errorMessages.street[0] : "",
      postal_code: errorMessages.postal_code ? errorMessages.postal_code[0] : "",
      city: errorMessages.city ? errorMessages.city[0] : "",
      country: errorMessages.country ? errorMessages.country[0] : "",
      region: errorMessages.region ? errorMessages.region[0] : ""
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setBankAccountFormErrors (error: any): void {
    const errorMessages = error.response.data
    this.bankAccountFormErrors = {
      owner: errorMessages.owner ? errorMessages.owner[0] : "",
      bank_name: errorMessages.bank_name ? errorMessages.bank_name[0] : "",
      iban: errorMessages.iban ? errorMessages.iban[0] : "",
      bic: errorMessages.bic ? errorMessages.bic[0] : ""
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setWhatWeDoFormErrors (error: any): void {
    const errorMessages = error.response.data

    this.whatWeDoFormErrors = {
      description_1: errorMessages.description_1 ? errorMessages.description_1[0] : "",
      url_1: errorMessages.url_1 ? errorMessages.url_1[0] : "",
      url_2: errorMessages.url_2 ? errorMessages.url_2[0] : "",
      photo: errorMessages.photo ? errorMessages.photo[0] : ""
    }
  }

  resetBaseInformationFormErrors (): void {
    Object.assign(this.fundingScopeFormErrors, { name: "" })

    Object.assign(this.addressFormErrors, {
      street: "",
      postal_code: "",
      city: "",
      country: "",
      region: ""
    })
  }

  resetWhatWeDoFormErrors (): void {
    Object.assign(this.whatWeDoFormErrors, {
      description_1: "",
      url_1: "",
      url_2: ""
    })
  }

  resetBankAccountFormErrors (): void {
    Object.assign(this.bankAccountFormErrors, {
      owner: "",
      bank_name: "",
      iban: "",
      bic: ""
    })
  }

  async saveBankAccount (): Promise<boolean> {
    this.resetBankAccountFormErrors()
    if (!this.bankAccountForm.termsAccepted) {
      this.showTermsError()
      return false
    }
    let saved = false
    await axios.post(API_URLS.FUNDING_SCOPE.SAVE_BANK_DATA(this.fundingScopeSlug), this.bankAccountForm).then(async () => {
      await this.fetchFundingScope()
      saved = true
      this.showSuccessMsg(null)
    }).catch((error) => {
      this.showError(null)
      this.setBankAccountFormErrors(error)
    })
    return saved
  }

  handlePhotoUpdated (): void {
    this.resetWhatWeDoFormErrors()
    this.fetchFundingScope()
  }

  async saveWhatWeDo (): Promise<boolean> {
    this.resetWhatWeDoFormErrors()
    let saved = false
    if (!this.hasImage) {
      this.showMissingImageError()
      this.whatWeDoFormErrors.photo = this.emptyFieldErrorMessage
    }
    if (!this.whatWeDoForm.description_1) {
      this.showRequiredFieldsError()
      this.whatWeDoFormErrors.description_1 = this.emptyFieldErrorMessage
    }
    if (!this.hasImage || !this.whatWeDoForm.description_1) {
      return saved
    }
    await axios.put(API_URLS.FUNDING_SCOPE.SAVE_WHAT_WE_DO(this.fundingScopeSlug), this.whatWeDoForm).then(async () => {
      this.showSuccessMsg(null)
      saved = true
    }).catch((error) => {
      if (error.response && error.response.status === 403 && error.response.data && error.response.data.detail) {
        this.showError({
          title: this.$gettext("Error"),
          message: error.response.data.detail
        })
      } else {
        this.setWhatWeDoFormErrors(error)
        this.showRequiredFieldsError()
      }
    })
    return saved
  }

  async saveBtnClicked (currentStep: IProcessingStep): Promise<boolean> {
    let saved = false
    if (currentStep.key === "basic") {
      if (this.isCreate) {
        saved = await this.createFundingScope()
      } else {
        saved = await this.saveBaseInformation()
      }
      await this.fetchFundingScope()
      await this.setAllData()
    } else if (currentStep.key === "what_we_do") {
      saved = await this.saveWhatWeDo()
    } else if (currentStep.key === "bank_account") {
      saved = await this.saveBankAccount()
    } else if (currentStep.key === "assignment") {
      saved = this.subCategoryForm.stepIsValid()
      this.checkAndValidateStep(currentStep)
      if (!saved) {
        const error = this.subCategoryForm.getError()
        this.showError(error)
      }
    } else if (currentStep.key === "contact_persons") {
      saved = this.saveContactPersons()
    } else if (["documents", "photos", "logo"].includes(currentStep.key)) {
      saved = true
    } else if (currentStep.key === "completition" && this.isSiteAdmin) {
      saved = await this.updateStatusByAdmin()
    }
    this.checkAndValidateStep(currentStep)
    return saved
  }

  get contactPersonStepIsValid (): boolean {
    return this.fundingScope && this.fundingScope.has_public_contact_person && this.fundingScope.has_internal_contact_person
  }

  saveContactPersons (): boolean {
    // not actually saved, but step is validated and error shown
    if (this.contactPersonStepIsValid) {
      this.showSuccessMsg(null)
    } else {
      this.showError({
        title: this.$gettext("Error"),
        message: this.$gettext("Please add at least one public contact person and one internal contact person.")
      })
    }
    return this.contactPersonStepIsValid
  }

  async saveAndNextBtnClicked (): Promise<void> {
    const saved = await this.saveBtnClicked(this.activeStep)
    if (saved) {
      this.gotoNextStepOrFinish(this.steps, this.activeStep, "funding_scope")
    }
  }

  gotoStep (step: IProcessingStep): void {
    this.checkAndValidateStep(this.activeStep)
    if (this.basicInfoFormCompleted) {
      this.setActiveStep(step)
    } else {
      this.showError(null)
    }
  }

  get tableUrl (): string {
    return this.isSiteAdmin ? "/site-admin/funding-scopes/" : "/account/funding-scopes/"
  }

  redirectToTable (): void {
    window.location.href = this.tableUrl
  }

  finishBtnClicked (): void {
    this.redirectToTable()
  }

  async updateStatusByAdmin (): Promise<boolean> {
    const data = {
      status: this.fundingScope ? this.fundingScope.status.choice : null
    }
    let saved = false
    await axios.patch(API_URLS.FUNDING_SCOPE.PUBLISH(this.fundingScopeSlug), data).then(async () => {
      saved = true
      this.showSuccessMsg(null)
      await this.fetchFundingScope()
    }).catch(() => {
      this.showError({
        title: this.$gettext("Error"),
        message: this.$gettext("Could not update the status. Is all data complete?")
      })
    })
    return saved
  }

  enterOrganizationBankData (): void {
    this.bankAccountForm.owner = this.fundingScope.related_organization.owner
    this.bankAccountForm.bank_name = this.fundingScope.related_organization.bank_name
    this.bankAccountForm.iban = this.fundingScope.related_organization.iban
    this.bankAccountForm.bic = this.fundingScope.related_organization.bic
  }

  enterOrganizationsAddress (): void {
    const relatedOrgaSlug = this.fundingScopeForm.related_organization
    let url = API_URLS.ORGANIZATIONS.RETRIEVE(relatedOrgaSlug)
    if (!this.isSiteAdmin) {
      url += "?own"
    }
    axios.get(url).then((response) => {
      const relatedOrga = response.data
      this.addressForm = {
        street: relatedOrga.street,
        additional_information: relatedOrga.additional_information,
        postal_code: relatedOrga.postal_code,
        city: relatedOrga.city,
        country: relatedOrga.country,
        region: relatedOrga.region_code
      }
    }).catch(() => {
      this.showError(null)
    })
  }

  async onLogoUploadClicked (): Promise<void> {
    if (!this.fundingScopeForm.name) {
      this.showError({
        title: this.$gettext("Error"),
        message: this.$gettext("Please enter a name for the funding scope first.")
      })
    }
    if (!this.fundingScopeSlug) {
      await this.saveBtnClicked(this.activeStep)
    }
  }

  updateLinks(updatedLinks: INavigationLink[]) {
    this.$set(this.fundingScope, 'links', updatedLinks)
  }

  async publishFundingScope (): Promise<void> {
    if (!this.termsAccepted) {
      this.showError({
        title: this.$gettext("Error"),
        message: this.$gettext("Please accept the terms and conditions.")
      })
      return
    }
    await axios.patch(API_URLS.FUNDING_SCOPE.PUBLISH(this.fundingScopeSlug)).then(async () => {
      this.showSuccessMsg(null)
      await this.fetchFundingScope()
    }).catch(() => {
      this.showError(null)
    })
  }

  openAddressBook (): void {
    this.contactPersonSelect.openAddressBook()
  }
}
